import React from 'react'
import Section from '../Section'
import Quiz from '../../../../components/Quiz'

export default props => (
  <Section
    color={props.color}
    fullHeight={props.fullHeight}
    paddingTop={props.paddingTop}
    paddingBottom={props.paddingBottom}
  >
    <Quiz text={props.text} color={props.color} />
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Quiz/Quiz.jsx